import Loader from "react-loader-spinner";
import SideBar from "../../Sections/SideBar";
import Navbar from "../../Sections/NavBar";
import MobileNav from "../../Sections/MobileNav";
import { useSelector } from "react-redux";
import "./index.css";

function CashDeposit() {
  // const userId = localStorage.getItem("id");

  const user = useSelector((state) => state.user.user);
  // const dispatch = useDispatch();

  

  if (!user) {
    return (
      <div
        className="text-center align-items-center"
        style={{ marginTop: "25%" }}
      >
        <Loader type="Oval" color="#1c743a" />
      </div>
    );
  }

  return (
    <>
      <Navbar dashboard />
      <MobileNav />
      <section>
        <div className="container-fluid">
          <div className="row">
            <SideBar />
            <div className="col-12 col-lg-6 col-xl-8 offset-lg-3 offset-xl-2 py-7 py-lg-9 px-lg-7">
              <h2 className="mb-5 text-primary fw-bold">Cash Deposit</h2>
              <div className="card shadow p-5">
                <div className="card-body">
                  <h3 className="card-title text-muted">
                  You can top up your Kegow wallet at any POS terminal or agent near you.
                  </h3>
                  <div className="mt-3 pt-5 wrapper">
                    <ol className="c-stepper">
                      <li className="c-stepper__item">
                        <div className="c-stepper__content">
                          <h3 className="c-stepper__title">Give cash to the POS agent</h3>
                          <p className="c-stepper__desc">Give the POS agent cash and request that funds be transfered to your Kegow account</p>
                        </div>
                      </li>
                      <li className="c-stepper__item1">
                        <div className="c-stepper__content">
                          <h3 className="c-stepper__title">Confirm your account</h3>
                          <p className="c-stepper__desc">Confirm that the correct amount has been deposited into your account.</p>
                        </div>
                      </li>
                      <li className="c-stepper__item2">
                        <div className="c-stepper__content">
                          <h3 className="c-stepper__title mt-2">Transaction successful</h3>
                        </div>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default CashDeposit;
